import { Group } from '@mantine/core';
import { Workflow } from '@/app/workflows/actions/interfaces';
import { EditName } from './EditName';
import { EditableComponentWrapper } from './EditableComponentWrapper';
import { NameDescriptionColumn } from '../atoms/NameDescriptionColumn';
import { WorkflowIcon } from '@/app/workflows/components/v6/atoms/WorkflowIcon';

type NameEditableColumnProps = {
  name: string;
  description: string;
  getIsRowExpanded: () => boolean;
  workflow: Workflow;
};

export const NameEditableColumn = ({ getIsRowExpanded, workflow }: NameEditableColumnProps) => {
  return (
    <Group gap='xs' wrap='nowrap'>
      <WorkflowIcon type={workflow.clientMetadata.type} />
      <EditableComponentWrapper
        editComponent={({ setIsEdit, workflow }) => (
          <EditName setIsEdit={setIsEdit} defaultName={workflow.name} workflow={workflow} />
        )}
        displayComponent={(w, onClick) => (
          <NameDescriptionColumn workflow={w} getIsRowExpanded={getIsRowExpanded} onClick={onClick} />
        )}
        workflow={workflow}
      />
    </Group>
  );
};
